import React, { ReactElement } from 'react'
import styled from 'styled-components'
import CollapseComponent from '@kunukn/react-collapse'

export const Collapse = ({
  children,
  expanded,
  transition = 'height 0.6s cubic-bezier(.4, 0, .2, 1)',
  collapseHeight = '0',
}: CollapseProps) => {
  return (
    <Container expanded={expanded}>
      <CollapseComponent
        isOpen={expanded}
        transition={transition}
        collapseHeight={collapseHeight}
      >
        {children}
      </CollapseComponent>
    </Container>
  )
}

export type CollapseProps = {
  children: ReactElement | string | null
  expanded: boolean
  transition?: string
  collapseHeight?: string
}

type ContainerProps = {
  expanded?: boolean
  transition?: string
}

const Container = styled.div<ContainerProps>``
